import gql from 'graphql-tag';

export default gql`
  mutation importShipment($path: String!) {
    importShipment(path: $path) {
      succeed
    }
  }
`;
